var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back")])
}
var staticRenderFns = []

export { render, staticRenderFns }